import { z } from 'zod';

/**
 * A single entry in the `project_progress_snapshots` table. Used by the
 * dashboard curva-S chart and the stalled-project alerter. `detail_json`
 * is already parsed into an array by the service layer.
 */
export const progressSnapshotDetailItemSchema = z.object({
  stageId: z.string(),
  stageName: z.string(),
  plannedPercent: z.number().min(0).max(100),
  actualPercent: z.number().min(0).max(100),
});

export const progressSnapshotSchema = z.object({
  id: z.string(),
  projectId: z.string(),
  snapshotAt: z.string(),
  plannedPercent: z.number().min(0).max(100),
  actualPercent: z.number().min(0).max(100),
  detail: z.array(progressSnapshotDetailItemSchema).nullable(),
  createdAt: z.string(),
});
export type ProgressSnapshot = z.infer<typeof progressSnapshotSchema>;
export type ProgressSnapshotDetailItem = z.infer<
  typeof progressSnapshotDetailItemSchema
>;
